module.exports = __webpack_public_path__ + "img/instagram-story.16be6056.svg";